import { __awaiter, __generator } from "tslib";
import { getAuthBearerValue } from '@gn-audio/core/common/utilities';
export var getDefaultHeaders = function (token, clientId) { return __awaiter(void 0, void 0, void 0, function () {
    var headerToken, _a;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!(typeof token === 'string')) return [3 /*break*/, 1];
                _a = token;
                return [3 /*break*/, 3];
            case 1: return [4 /*yield*/, token];
            case 2:
                _a = _c.sent();
                _c.label = 3;
            case 3:
                headerToken = _a;
                return [2 /*return*/, (_b = {},
                        _b["Authorization" /* Header.Authorization */] = getAuthBearerValue(headerToken),
                        _b["Content-Type" /* Header.ContentType */] = "application/json" /* HttpContentType.Json */,
                        _b["x-dw-client-id" /* Header.ClientId */] = clientId,
                        _b)];
        }
    });
}); };
